export const SERIES_UPDATE_START = 'SERIES_UPDATE_START';
export const SERIES_UPDATE_SUCCESS = 'SERIES_UPDATE_SUCCESS';
export const SERIES_UPDATE_ERROR = 'SERIES_UPDATE_ERROR';
export const SERIES_UPDATE_LOADING = 'SERIES_UPDATE_LOADING';
export const SERIES_UPDATE_CANCEL = 'SERIES_UPDATE_CANCEL';

export type Actions = {
  SERIES_UPDATE_START: { type: typeof SERIES_UPDATE_START; payload: boolean };
  SERIES_UPDATE_LOADING: { type: typeof SERIES_UPDATE_LOADING; payload: boolean };
  SERIES_UPDATE_SUCCESS: { type: typeof SERIES_UPDATE_SUCCESS; payload: any };
  SERIES_UPDATE_ERROR: { type: typeof SERIES_UPDATE_ERROR; payload: any };
  SERIES_UPDATE_CANCEL: { type: typeof SERIES_UPDATE_CANCEL; payload: any };
};
// Action Creators
export const actionCreators = {
  seriesUpdateStart: (payload: any): Actions[typeof SERIES_UPDATE_START] => ({
    type: SERIES_UPDATE_START,
    payload,
  }),
  seriesUpdateError: (payload: any): Actions[typeof SERIES_UPDATE_ERROR] => ({
    type: SERIES_UPDATE_ERROR,
    payload,
  }),
  seriesUpdateSuccess: (payload: any): Actions[typeof SERIES_UPDATE_SUCCESS] => {
    return ({ type: SERIES_UPDATE_SUCCESS, payload: payload});
  }
  ,
  seriesUpdateLoading: (payload: boolean): Actions[typeof SERIES_UPDATE_LOADING] => ({
    type: SERIES_UPDATE_LOADING,
    payload,
  }),
  seriesUpdateCancel: (payload: boolean): Actions[typeof SERIES_UPDATE_CANCEL] => ({
    type: SERIES_UPDATE_CANCEL,
    payload,
  }),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/accounts/series-update/actions.ts